import { useSearchParams } from 'react-router';

export const POPUP_ID_SEARCH_PARAM = 'popupId';

export function usePopupId() {
  const [params] = useSearchParams();

  return {
    popupId: params.get(POPUP_ID_SEARCH_PARAM),
  };
}
